import React, { useEffect } from 'react';

import { Container, Pagination } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import classes from './NgzChallengesList.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { ChallengesListPageTitle } from './ChallengesListPageTitle/ChallengesListPageTitle';
import { challengesListStore } from '../../stores/challengesListStore';
import { EmptyList } from '../../../shared/components/ui-components/EmptyList/EmptyList';
import { TitleRow } from './TitleRow/TitleRow';
import { FilterRow } from './FilterRow/FilterRow';
import { ChallengeRow } from './ChallengeRow/ChallengeRow';

const NgzChallengesList = observer(() => {
  const { challengesList, filterMethods, getChallengesList, setDefaultValues } =
    challengesListStore;

  const { isShowPagination, isShowPlaceholder, isSearchUsed, getPaginationProps } =
    filterMethods;

  useEffect(() => {
    getChallengesList();

    return setDefaultValues;
  }, []);

  const paginationProps = getPaginationProps();

  return (
    <Container>
      <ChallengesListPageTitle />
      <div className={classes.challengesTable}>
        <TitleRow />
        <FilterRow />
        {challengesList.map((challenge) => (
          <ChallengeRow key={challenge.challengeId} challenge={challenge} />
        ))}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        isSearch={isSearchUsed}
        description="There are no challenges"
      />
      {isShowPagination && <Pagination {...paginationProps} />}
    </Container>
  );
});

angularizeWithProviders(NgzChallengesList, 'ngzChallengesList', {});
